export function getCanonicalUrl() {
	return `${window.location.origin}${window.location.pathname}`;
}
